import "@fortawesome/fontawesome-free/css/all.min.css";

import "@/css/bootstrap.css";
import "@/css/style.css";
import "@/css/main.css";
import { Outlet } from "react-router";

export function TemplateLogin() {
	return (
		<Outlet />
	);
}
